module.exports = __webpack_public_path__ + "static/media/add_active.c6aab25e.svg";